import React from 'react';
import { Card, CardBody } from '@aidkitorg/component-library';
import { ApplicantGroupFilterConfig } from '@aidkitorg/types/lib/admin-panel/filters';
import { useLocalizedStrings } from '../../../Localization';
import { renderFilterGroup } from '../../shared/utils/filterDisplayUtils';

interface AppliedFiltersDisplayProps {
  filters: ApplicantGroupFilterConfig;
  fieldLabels?: Record<string, string>;
}

export const AppliedFiltersDisplay: React.FC<AppliedFiltersDisplayProps> = ({
  filters,
  fieldLabels
}) => {
  const L = useLocalizedStrings();
  const strings = L.admin_panel.settings.applicant_groups;

  if (!filters || !filters.enabled || !filters.config || !filters.config.conditions ||
      filters.config.conditions.length === 0) {
    return null;
  }

  const badges = renderFilterGroup(filters.config, fieldLabels);

  return (
    <Card className="rounded-md w-100">
      <CardBody>
        <div className="text-md font-medium text-gray-700 mb-3 ml-1">{strings.applied_filters}</div>
        <div className="flex flex-wrap gap-2">
          {badges}
        </div>
      </CardBody>
    </Card>
  );
};
